/**
 * @uruganda/http — axios instance avec interceptors plateforme (token, org optionnelle, 401).
 * ESM (Vite / bundlers modernes).
 */
import axios from 'axios'

export function createApiRoot(backendUrl) {
  const b = (backendUrl || '').replace(/\/$/, '')
  return b ? `${b}/api` : '/api'
}

export function attachUrugandaInterceptors(client, opts = {}) {
  const {
    includeOrgHeaders = false,
    loginPath = '/login',
    clearProjectOn401 = true,
  } = opts

  client.interceptors.request.use((config) => {
    const token =
      typeof localStorage !== 'undefined' &&
      (localStorage.getItem('access_token') || localStorage.getItem('token'))
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    if (includeOrgHeaders && typeof localStorage !== 'undefined') {
      const id =
        localStorage.getItem('organization_id') ||
        localStorage.getItem('current_org_id')
      if (id) {
        config.headers['X-Organization-ID'] = id
        config.headers['X-Org-Id'] = id
      }
    }
    return config
  })

  client.interceptors.response.use(
    (r) => r,
    (error) => {
      if (error.response?.status === 401 && typeof window !== 'undefined') {
        localStorage.removeItem('token')
        localStorage.removeItem('access_token')
        if (clearProjectOn401) {
          localStorage.removeItem('project_id')
        }
        localStorage.removeItem('organization_id')
        localStorage.removeItem('current_org_id')
        const path = typeof loginPath === 'function' ? loginPath() : loginPath
        window.location.href = path
      }
      return Promise.reject(error)
    }
  )
}

export function createPlatformAxios(opts) {
  const client = axios.create()
  attachUrugandaInterceptors(client, opts)
  return client
}
